import analyticsNotesCommon from './analyticsNotesCommon';
import analyticsNotesMonthly from './analyticsNotesMonthly';
import analyticsNotes from './analyticsNotesYearly';
import calculationCommon from './calculationCommon';
import foreignTradeByCountries from './foreignTradeByCountries';
import foreignTradeByProducts from './foreignTradeByProducts';
import foreignTradeByRegions from './foreignTradeByRegions';
import ftsCommon from './ftsCommon';
import ftsMonthly from './ftsMonthly';
import ftsWeekly from './ftsWeekly';
import productAggregated from './productAggregated';
import regionAggregated from './regionAggregated';
import userGroups from './userGroups';
import vedCommon from './vedCommon';

export default {
  regionAggregated,
  productAggregated,
  analyticsNotes,
  analyticsNotesMonthly,
  analyticsNotesCommon,
  foreignTradeByRegions,
  foreignTradeByProducts,
  foreignTradeByCountries,
  vedCommon,
  ftsCommon,
  ftsMonthly,
  ftsWeekly,
  calculationCommon,
  userGroups,
};
